import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-open-1"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M1 3.5V20L4 10L19.5 10L19.5 6L10 6L7 3.5H1Z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 20L19.5 20L22.5 10L4 10L1 20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 20H19.5L22.5 10H4L1 20ZM1 20L1 3.5L7 3.5L10 6L19.5 6L19.5 10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderOpen1 = Vue.extend<IconProps>({
  name: 'FolderOpen1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'folder-open-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FolderOpen1;
